
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"staffFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"staff"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"first_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"last_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"full_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"photo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"signature"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"zoom_link"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"zoom_meeting_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"zoom_passcode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"theme_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"theme"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"isCoach"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isCoachAndEvaluator"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isEvaluator"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"coachAllClientsAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"coachActiveClientsAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"coachActiveNotVacationClientsAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"coachVacationClientsAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"coachInactiveClientsAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"evaluatorAllClientsAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"evaluatorActiveClientsAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"evaluatorActiveNotVacationClientsAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"evaluatorVacationClientsAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"evaluatorInactiveClientsAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"coachAllFamiliesAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"coachActiveFamiliesAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"coachActiveNotVacationFamiliesAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"coachVacationFamiliesAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"coachInactiveFamiliesAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"evaluatorAllFamiliesAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"evaluatorActiveFamiliesAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"evaluatorActiveNotVacationFamiliesAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"evaluatorVacationFamiliesAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"evaluatorInactiveFamiliesAmount"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":865}};
    doc.loc.source = {"body":"fragment staffFields on staff {\n  user_id\n  first_name\n  last_name\n  full_name\n  photo\n  signature\n  zoom_link\n  zoom_meeting_id\n  zoom_passcode\n  theme_id\n  theme {\n    name\n  }\n  isCoach\n  isCoachAndEvaluator\n  isEvaluator\n  coachAllClientsAmount\n  coachActiveClientsAmount\n  coachActiveNotVacationClientsAmount\n  coachVacationClientsAmount\n  coachInactiveClientsAmount\n  evaluatorAllClientsAmount\n  evaluatorActiveClientsAmount\n  evaluatorActiveNotVacationClientsAmount\n  evaluatorVacationClientsAmount\n  evaluatorInactiveClientsAmount\n  coachAllFamiliesAmount\n  coachActiveFamiliesAmount\n  coachActiveNotVacationFamiliesAmount\n  coachVacationFamiliesAmount\n  coachInactiveFamiliesAmount\n  evaluatorAllFamiliesAmount\n  evaluatorActiveFamiliesAmount\n  evaluatorActiveNotVacationFamiliesAmount\n  evaluatorVacationFamiliesAmount\n  evaluatorInactiveFamiliesAmount\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["staffFields"] = oneQuery(doc, "staffFields");
        
